import { ApiHandler } from '@eshop/api-client'
import type Rental from '@eshop/type/rental'

import { getPageType } from '#/local/service/dataLayer'

import { Config } from '#/global/helper/Config'

type ProductRental = Rental.Product<'detail' | 'price'>

const createPayload = (product: ProductRental, quantitySales: number, breadcrumb?: string) => {
    return {
        event: 'add_to_cart',
        pageType: getPageType(),
        ecommerce: {
            currency: product.price.currencyCode,
            value: product.detail.priceNoVatOrigin * quantitySales,
            items: [{
                item_id: product.code,
                item_name: product.detail.title,
                item_brand: '',
                item_category: breadcrumb ?? '',
                price: product.detail.priceNoVatOrigin,
                quantity: quantitySales,
            }],
        },
        _clear: true,
    }
}

const pushEventAddToCartRental = (product: ProductRental, quantitySales: number) => {
    window.dataLayer ??= []

    const api = new ApiHandler({
        path: '/product/get-breadcrumb-rental-by-id',
        parameters: {
            id: product.detail.categoryId,
        },
    })

    api.addResponseHandler('4xx', async () => {
        await api.handleError({
            hideMessage: !Config.isDev(),
        })
    })

    api.send()
        .then(categories => categories?.map(category => category.title).join(' > '))
        .then((breadcrumb) => {
            const payload = createPayload(product, quantitySales, breadcrumb)
            window.dataLayer?.push(payload)
        })
        .catch((error) => {
            console.error('[GlobalListener-PushEventAddToCartRental]:', error)
        })
}
export default pushEventAddToCartRental
